import { render } from "./MChangeLanguageButton.vue?vue&type=template&id=07c28ea8&scoped=true"
import script from "./MChangeLanguageButton.vue?vue&type=script&lang=js"
export * from "./MChangeLanguageButton.vue?vue&type=script&lang=js"

import "./MChangeLanguageButton.vue?vue&type=style&index=0&id=07c28ea8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c28ea8"]])

export default __exports__